const splitHeatId = (heatId: string) => {
  const match = /^(.*?)(\d+)$/.exec(heatId);
  return match
    ? { prefix: match[1], number: BigInt(match[2] ?? "") }
    : { prefix: heatId, number: null };
};

const isNextHeatId = (previous: string, next: string) => {
  const previousParts = splitHeatId(previous);
  const nextParts = splitHeatId(next);
  return (
    previousParts.number !== null &&
    nextParts.number === previousParts.number + 1n &&
    nextParts.prefix === previousParts.prefix
  );
};

export const formatHeatIdRanges = (heatIds: string[]) => {
  const runs = [...heatIds]
    .sort((left, right) =>
      left.localeCompare(right, undefined, { numeric: true })
    )
    .reduce<{ first: string; last: string }[]>((accumulated, heatId) => {
      const lastRun = accumulated.at(-1);
      return lastRun && isNextHeatId(lastRun.last, heatId)
        ? [...accumulated.slice(0, -1), { ...lastRun, last: heatId }]
        : [...accumulated, { first: heatId, last: heatId }];
    }, []);
  if (runs.length === 0) return "—";
  return runs
    .map(({ first, last }) => (first === last ? first : `${first}–${last}`))
    .join(", ");
};
